import React from 'react';

import './overlayComponent.css';

const OverlayComponent = ({children = <></>}) => {
  return (
    <div className="et-v2-overlay-container">
      <div className="et-v2-overlay-container-content-wrap">{children}</div>
    </div>
  );
};

export default OverlayComponent;
